(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider, index) => {
			if (slider.swiper) return;

			const paginationEl = slider.querySelector(".product-pagination .swiper-pagination");
			const nextEl = slider.querySelector(".product-button-group .swiper-button-next");
			const prevEl = slider.querySelector(".product-button-group .swiper-button-prev");

			const productSlider = new Swiper(slider, {
				nested: true,
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				touchRatio: 1,
				touchAngle: 45,
				threshold: 5,
				preventClicks: true,
				preventClicksPropagation: true,
				pagination: {
					el: paginationEl || slider.querySelector(".swiper-pagination") || ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl || slider.querySelector(".swiper-button-next") || ".product-button-group .swiper-button-next",
					prevEl: prevEl || slider.querySelector(".swiper-button-prev") || ".product-button-group .swiper-button-prev",
				},
			});
		});
	};

	window.initProductCardSlider = initSlider;

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initSlider);
	} else {
		initSlider();
	}

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();

